import axios from 'axios';
import NProgress from 'nprogress';


const baseURL = process.env.VUE_APP_API_DOMAIN
var user = process.env.VUE_APP_API_USERNAME
var pass = process.env.VUE_APP_API_PASS
var basicAuth = 'Basic ' + btoa( user + ':' + pass)

const instance = axios.create({
	baseURL,
	headers: { Authorization: basicAuth },
   	withCredentials: true
})

// before a request is made start the nprogress
instance.interceptors.request.use(config => {
  NProgress.start()
  return config
})

// before a response is returned stop nprogress
instance.interceptors.response.use(response => {
  NProgress.done()
  return response
},
function (error) {
  NProgress.done()
  return error.response
})


const instanceNoAuth = axios.create({
	baseURL
})

instanceNoAuth.interceptors.request.use(config => {
  NProgress.start()
  return config
})

// before a response is returned stop nprogress
instanceNoAuth.interceptors.response.use(response => {
  NProgress.done()
  return response
},
function (error) {
  NProgress.done()
  return error.response
})

var exportInstance = {
	auth: instance,
	noAuth: instanceNoAuth
}

export default exportInstance
